// Big sheets are imported in parts of at most PART_ROWS rows, one after the
// other. Each part is checked and saved like a file of its own; importing is
// safe to repeat, so a part that stopped halfway can simply be run again.

export const PART_ROWS = 20_000

/** How many parts a sheet with `dataRows` rows (header excluded) splits into. */
export function partCount(dataRows: number, size = PART_ROWS): number {
  return Math.max(1, Math.ceil(dataRows / size))
}

/** Data-row indexes [start, end) of a part. */
export function partRange(
  part: number,
  dataRows: number,
  size = PART_ROWS,
): { start: number; end: number } {
  const start = Math.min(part * size, dataRows)
  return { start, end: Math.min(start + size, dataRows) }
}

/**
 * Products saved after `chunksDone` of the chunks from planToChunks: every
 * chunk holds `chunkSize` products except the last.
 */
export function productsSaved(chunksDone: number, total: number, chunkSize = 100): number {
  return Math.min(total, chunksDone * chunkSize)
}
